/*global google, googleMaps*/

import { Loader } from '@googlemaps/js-api-loader';
import animateScrollTo from 'animated-scroll-to';

const eight29Maps = document.querySelectorAll('.eight29-google-map');
const maps = [];

const defaultIcon =
	'<svg width="29" height="37" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="m14.501 0c4.248 0.079 7.854 1.644 10.73 4.871 2.285 2.563 3.477 5.583 3.742 9.041 0.186 2.428-0.552 4.6-1.55 6.698-1.843 3.871-4.318 7.325-7.04 10.595-1.416 1.701-2.887 3.356-4.366 5.001-0.956 1.062-2.042 1.05-3.014-4e-3 -3.718-4.035-7.238-8.229-10.034-13.004-1.26-2.152-2.359-4.38-2.81-6.872-0.322-1.78-0.127-3.556 0.35-5.279 1.45-5.229 4.746-8.694 9.786-10.408 1.353-0.46 2.768-0.66 4.206-0.639z" fill="#0d0d0d"/><path d="m14.5 10.182c-2.589 0.02-4.4661 2.0618-4.4941 4.5898-0.028 2.545 2.0061 4.6257 4.4961 4.6367 2.475 0.011 4.5156-2.0751 4.5176-4.6191h0.001953c0.018-2.471-1.9325-4.6274-4.5215-4.6074z" fill="#fff"/></svg>';

const selectedIcon =
	'<svg width="29" height="37" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="m14.501 0c4.248 0.079 7.854 1.644 10.73 4.871 2.285 2.563 3.477 5.583 3.742 9.041 0.186 2.428-0.552 4.6-1.55 6.698-1.843 3.871-4.318 7.325-7.04 10.595-1.416 1.701-2.887 3.356-4.366 5.001-0.956 1.062-2.042 1.05-3.014-4e-3 -3.718-4.035-7.238-8.229-10.034-13.004-1.26-2.152-2.359-4.38-2.81-6.872-0.322-1.78-0.127-3.556 0.35-5.279 1.45-5.229 4.746-8.694 9.786-10.408 1.353-0.46 2.768-0.66 4.206-0.639z" fill="#6200ee"/><path d="m14.5 10.182c-2.589 0.02-4.4661 2.0618-4.4941 4.5898-0.028 2.545 2.0061 4.6257 4.4961 4.6367 2.475 0.011 4.5156-2.0751 4.5176-4.6191h0.001953c0.018-2.471-1.9325-4.6274-4.5215-4.6074z" fill="#fff"/></svg>';

const loader = new Loader({
	apiKey: googleMaps.google_maps_api_key,
	version: 'weekly',
});

const mapOptions = {
	center: {
		lat: 0,
		lng: 0,
	},
	zoom: 4,
	mapTypeControl: false,
	fullscreenControl: false,
	streetViewControl: false,
	scaleControl: false,
	zoomControl: true,
};

if (
	undefined !== googleMaps.google_maps_style &&
	'' !== googleMaps.google_maps_style
) {
	mapOptions.styles = JSON.parse(googleMaps.google_maps_style);
}

const loadMaps = (eight29Map) => {
	const markers = eight29Map.querySelectorAll('.eight29-google-map__marker');
	const block = eight29Map.closest('.block-attraction-map');

	if (block) {
		const blockId =
			block.getAttribute('id') +
			eight29Map
				.closest('.block-attraction-map__map-wrapper')
				.getAttribute('data-map-id');

		maps[blockId] = new google.maps.Map(eight29Map, mapOptions);
		maps[blockId].markers = [];

		if (markers.length) {
			markers.forEach((marker) => {
				addMarker(marker, maps[blockId]);
			});
		}

		const toggleButtons = block.querySelectorAll(
			'.block-attraction-map__map-toggle-button'
		);
		const filterButtons = block.querySelectorAll(
			'.block-attraction-map__map-filter-button'
		);
		const locationButtons = block.querySelectorAll(
			'.block-attraction-map__map-attraction-button'
		);

		if (toggleButtons.length) {
			toggleButtons.forEach((toggleButton) => {
				toggleButton.addEventListener('click', toggleMap);
			});
		}

		if (filterButtons.length) {
			filterButtons.forEach((filterButton) => {
				filterButton.addEventListener('click', toggleFilter);
			});
		}

		if (locationButtons.length) {
			locationButtons.forEach((locationButton) => {
				locationButton.addEventListener('click', selectLocation);
			});
		}

		filterMarkers(maps[blockId]);

		google.maps.event.addDomListener(window, 'resize', function () {
			centerMap(maps[blockId]);
		});

		centerMap(maps[blockId]);
	}
};

const toggleMap = (e) => {
	const block = e.currentTarget.closest('.block-attraction-map');

	if (block && e.currentTarget.hasAttribute('data-map-id')) {
		const mapId = e.currentTarget.getAttribute('data-map-id');
		const blockId = block.getAttribute('id') + mapId;
		const elements = block.querySelectorAll(
			'.block-attraction-map__map-wrapper, .block-attraction-map__map-content, .block-attraction-map__map-filters'
		);

		if (e.currentTarget.parentElement.children) {
			for (const child of e.currentTarget.parentElement.children) {
				child.classList.remove('active');
			}
		}

		if (elements) {
			elements.forEach((element) => {
				if (element.getAttribute('data-map-id') === mapId) {
					element.classList.add('active');
					element.setAttribute('aria-hidden', 'false');
				} else {
					element.classList.remove('active');
					element.setAttribute('aria-hidden', 'true');
				}
			});
		}

		e.currentTarget.classList.add('active');

		if (maps[blockId]) {
			resetMarkers(block, maps[blockId]);
			filterMarkers(maps[blockId]);
		}
	}
};

const toggleFilter = (e) => {
	const block = e.currentTarget.closest('.block-attraction-map');

	if (block && e.currentTarget.hasAttribute('data-category')) {
		const mapId = e.currentTarget.parentElement.getAttribute('data-map-id');
		const blockId = block.getAttribute('id') + mapId;
		const categoryId = e.currentTarget.getAttribute('data-category');
		const locations = block.querySelectorAll(
			'.block-attraction-map__map-content[data-map-id="' +
				mapId +
				'"] .block-attraction-map__map-attractions'
		);

		if (e.currentTarget.parentElement.children) {
			for (const child of e.currentTarget.parentElement.children) {
				child.classList.remove('active');
			}
		}

		if (locations) {
			locations.forEach((location) => {
				if (location.getAttribute('data-category') === categoryId) {
					location.classList.add('active');
					location.setAttribute('aria-hidden', 'false');
				} else {
					location.classList.remove('active');
					location.setAttribute('aria-hidden', 'true');
				}
			});
		}

		e.currentTarget.classList.add('active');

		if (maps[blockId]) {
			filterMarkers(maps[blockId]);

			resetMarkers(block, maps[blockId]);
		}
	}
};

const resetMarkers = (block, map) => {
	const activeLocations = block.querySelectorAll(
		'.block-attraction-map__map-attraction.active'
	);

	if (activeLocations) {
		activeLocations.forEach((button) => {
			button.classList.remove('active');
		});
	}

	map.markers.forEach((thisMarker) => {
		thisMarker.icon = {
			anchor: new google.maps.Point(14.5, 37),
			url:
				'data:image/svg+xml;charset=utf-8,' +
				encodeURIComponent(defaultIcon),
		};

		thisMarker.setOptions(thisMarker);
		thisMarker.setZIndex(1);
	});
};

const selectLocation = (e) => {
	const locationButton = e.currentTarget;
	const block = locationButton.closest('.block-attraction-map');
	const mapWrapper = block.querySelector(
		'.block-attraction-map__map-wrapper'
	);

	if (window.innerWidth < 768 && mapWrapper.offsetTop < window.scrollY) {
		animateScrollTo(mapWrapper, {
			speed: 500,
		});
	}

	const blockId =
		block.getAttribute('id') +
		locationButton
			.closest('.block-attraction-map__map-content')
			.getAttribute('data-map-id');

	if (maps[blockId] && maps[blockId].markers) {
		maps[blockId].markers.forEach((marker) => {
			if (
				marker.title &&
				marker.title === locationButton.getAttribute('data-title')
			) {
				updateMarkersAndLocations(
					locationButton,
					maps[blockId],
					marker
				);

				centerMap(maps[blockId]);
			}
		});
	}
};

const updateMarkersAndLocations = (locationButton, map, marker) => {
	const contentElement = locationButton.closest(
		'.block-attraction-map__map-content'
	);

	if (contentElement) {
		animateScrollTo(locationButton, {
			speed: 300,
			elementToScroll: contentElement,
		});

		const locations = contentElement.querySelectorAll(
			'.block-attraction-map__map-attraction'
		);

		if (locations) {
			locations.forEach((location) => {
				location.classList.remove('active');
			});
		}

		locationButton.parentElement.classList.add('active');

		map.markers.forEach((thisMarker) => {
			thisMarker.icon = {
				anchor: new google.maps.Point(14.5, 37),
				url:
					'data:image/svg+xml;charset=utf-8,' +
					encodeURIComponent(defaultIcon),
			};

			thisMarker.setOptions(thisMarker);
			thisMarker.setZIndex(1);
		});

		marker.icon = {
			anchor: new google.maps.Point(14.5, 37),
			url:
				'data:image/svg+xml;charset=utf-8,' +
				encodeURIComponent(selectedIcon),
		};

		marker.setOptions(marker);
		marker.setZIndex(2);
	}
};

const addMarker = (thisMarker, map) => {
	const latlng = new google.maps.LatLng(
		thisMarker.getAttribute('data-lat'),
		thisMarker.getAttribute('data-lng')
	);

	const markerSettings = {
		position: latlng,
		map,
		markerOverlay: thisMarker.innerHTML,
		categories: thisMarker.getAttribute('data-categories'),
		title: thisMarker.getAttribute('data-title'),
		icon: {
			anchor: new google.maps.Point(14.5, 37),
			url:
				'data:image/svg+xml;charset=utf-8,' +
				encodeURIComponent(defaultIcon),
		},
	};

	const marker = new google.maps.Marker(markerSettings);

	// add to array
	map.markers.push(marker);

	google.maps.event.addListener(marker, 'click', function () {
		if (marker.title) {
			const mapWrapper = map
				.getDiv()
				.closest('.block-attraction-map__map-wrapper');
			const block = map.getDiv().closest('.block-attraction-map');

			if (mapWrapper && block) {
				const mapId = mapWrapper.getAttribute('data-map-id');

				const locationButton = block.querySelector(
					'.block-attraction-map__map-content[data-map-id="' +
						mapId +
						'"] .block-attraction-map__map-attraction-button[data-title="' +
						marker.title +
						'"]'
				);

				if (locationButton) {
					updateMarkersAndLocations(locationButton, map, marker);
				}
			}
		}
	});
};

const filterMarkers = (map) => {
	const mapWrapper = map
		.getDiv()
		.closest('.block-attraction-map__map-wrapper');

	if (mapWrapper && mapWrapper.hasAttribute('data-map-id')) {
		const activeItems = mapWrapper.parentElement.querySelectorAll(
			'.block-attraction-map__map-filters[data-map-id="' +
				mapWrapper.getAttribute('data-map-id') +
				'"] .block-attraction-map__map-filter-button.active'
		);

		const categories = [];

		if (activeItems.length) {
			activeItems.forEach((activeItem) => {
				if (activeItem.hasAttribute('data-category')) {
					categories.push(activeItem.getAttribute('data-category'));
				}
			});
		}

		map.markers.forEach((marker) => {
			if (undefined !== marker.categories) {
				if (
					0 === categories.length ||
					categories.some((category) =>
						marker.categories.includes(category)
					)
				) {
					marker.setVisible(true);
				} else {
					marker.setVisible(false);
				}
			} else {
				marker.setVisible(true);
			}
		});

		centerMap(map);
	}
};

const centerMap = (map) => {
	const bounds = new google.maps.LatLngBounds();
	const selectedBounds = new google.maps.LatLngBounds();
	let selected = false;
	let visibleMarkers = 0;

	// loop through all markers and create bounds
	for (let i = 0; i < map.markers.length; i++) {
		if (map.markers[i].visible === true) {
			visibleMarkers++;

			const latlng = new google.maps.LatLng(
				map.markers[i].position.lat(),
				map.markers[i].position.lng()
			);

			bounds.extend(latlng);

			if (
				map.markers[i].icon.url.includes(
					'%23003d4c%22%2F%3E%3C%2Fsvg%3E'
				)
			) {
				selectedBounds.extend(latlng);
				selected = true;
			}
		}
	}

	let center = bounds.getCenter();

	if (true === selected) {
		center = selectedBounds.getCenter();
	}

	// only 1 marker?
	if (visibleMarkers === 1) {
		// set center of map
		map.setCenter(center);
		map.setZoom(12);
	} else if (true === selected) {
		map.panTo(center);
	} else {
		map.setCenter(center);
		map.fitBounds(bounds);
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (eight29Maps.length) {
			loader.load().then(() => {
				eight29Maps.forEach((eight29Map) => {
					loadMaps(eight29Map);
				});
			});
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
